import React from "react";
import { Form } from "antd";
import EcSelect from "@/components/EcSelect";
import ShopDTO from "@/dto/shop/ShopDTO";
import ShopType from "@/enum/ShopType";
import OrderSellerRemarksFlag from "@/enum/OrderSellerRemarksFlag";
import SellerRemarkFlagIcon from "@/components/SellerRemarkFlagIcon";
import SellerFlagNameMap from "@/map/SellerFlagNameMap";

interface SellerFlagFieldProps {
    shop?: ShopDTO;
}

const SellerFlagField: React.FC<SellerFlagFieldProps> = (props) => {
    const { shop } = props;

    function getColorText(flag: OrderSellerRemarksFlag) {
        return SellerFlagNameMap[flag]?.replace("色", "");
    }

    function renderResult(flags: OrderSellerRemarksFlag[]) {
        return flags.map((flag) => getColorText(flag)).join();
    }

    const data = [
        { value: OrderSellerRemarksFlag.NONE, label: "无旗帜" },
        {
            value: OrderSellerRemarksFlag.RED,
            label: (
                <span>
                    <SellerRemarkFlagIcon orderSellerRemarksFlag={OrderSellerRemarksFlag.RED} />
                    <span className="ml5">{getColorText(OrderSellerRemarksFlag.RED)}</span>
                </span>
            ),
        },
        {
            value: OrderSellerRemarksFlag.YELLOW,
            label: (
                <span>
                    <SellerRemarkFlagIcon orderSellerRemarksFlag={OrderSellerRemarksFlag.YELLOW} />
                    <span className="ml5">{getColorText(OrderSellerRemarksFlag.YELLOW)}</span>
                </span>
            ),
        },
        {
            value: OrderSellerRemarksFlag.GREEN,
            label: (
                <span>
                    <SellerRemarkFlagIcon orderSellerRemarksFlag={OrderSellerRemarksFlag.GREEN} />
                    <span className="ml5">{getColorText(OrderSellerRemarksFlag.GREEN)}</span>
                </span>
            ),
        },
        {
            value: OrderSellerRemarksFlag.BLUE,
            label: (
                <span>
                    <SellerRemarkFlagIcon orderSellerRemarksFlag={OrderSellerRemarksFlag.BLUE} />
                    <span className="ml5">{getColorText(OrderSellerRemarksFlag.BLUE)}</span>
                </span>
            ),
        },
        {
            value: OrderSellerRemarksFlag.PURPLE,
            label: (
                <span>
                    <SellerRemarkFlagIcon orderSellerRemarksFlag={OrderSellerRemarksFlag.PURPLE} />
                    <span className="ml5">{getColorText(OrderSellerRemarksFlag.PURPLE)}</span>
                </span>
            ),
        },
    ];

    if (!shop || [ShopType.TAOBAO].includes(shop?.type)) {
        data.push(
            ...[
                {
                    value: OrderSellerRemarksFlag.ORANGE,
                    label: (
                        <span>
                            <SellerRemarkFlagIcon orderSellerRemarksFlag={OrderSellerRemarksFlag.ORANGE} />
                            <span className="ml5">{getColorText(OrderSellerRemarksFlag.ORANGE)}</span>
                        </span>
                    ),
                },
                {
                    value: OrderSellerRemarksFlag.LIGHT_BLUE,
                    label: (
                        <span>
                            <SellerRemarkFlagIcon orderSellerRemarksFlag={OrderSellerRemarksFlag.LIGHT_BLUE} />
                            <span className="ml5">{getColorText(OrderSellerRemarksFlag.LIGHT_BLUE)}</span>
                        </span>
                    ),
                },
                {
                    value: OrderSellerRemarksFlag.PINK,
                    label: (
                        <span>
                            <SellerRemarkFlagIcon orderSellerRemarksFlag={OrderSellerRemarksFlag.PINK} />
                            <span className="ml5">{getColorText(OrderSellerRemarksFlag.PINK)}</span>
                        </span>
                    ),
                },
                {
                    value: OrderSellerRemarksFlag.DARK_GREEN,
                    label: (
                        <span>
                            <SellerRemarkFlagIcon orderSellerRemarksFlag={OrderSellerRemarksFlag.DARK_GREEN} />
                            <span className="ml5">{getColorText(OrderSellerRemarksFlag.DARK_GREEN)}</span>
                        </span>
                    ),
                },
                {
                    value: OrderSellerRemarksFlag.PEACH,
                    label: (
                        <span>
                            <SellerRemarkFlagIcon orderSellerRemarksFlag={OrderSellerRemarksFlag.PEACH} />
                            <span className="ml5">{getColorText(OrderSellerRemarksFlag.PEACH)}</span>
                        </span>
                    ),
                },
            ],
        );
    }

    return (
        <Form.Item label={<span className="search-field-label">旗帜颜色</span>} name="sellerFlags">
            <EcSelect data={data} placeholder="所有旗帜颜色" multiple renderResult={renderResult} />
        </Form.Item>
    );
};

export default React.memo(SellerFlagField);
